import { Field, Checkbox } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { CwdChartSection } from 'Components/Worksheets/MaximumDryDensityWorksheet/Shared';
import { useSelector } from 'react-redux';

let BsCompactionCwdSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const enterConvertedWetDensity =
    useSelector(createWorksheetSelector!('Preparation.EnterConvertedWetDensity')) ?? false;

  return (
    <>
      <ListFieldSection>
        <Field input={<Checkbox />} name="Preparation.EnterConvertedWetDensity" />
      </ListFieldSection>
      {enterConvertedWetDensity && <CwdChartSection />}
    </>
  );
};

BsCompactionCwdSection = withInjectedProps(BsCompactionCwdSection);

export { BsCompactionCwdSection };
export default BsCompactionCwdSection;
